import type { FC } from "react"

import styles from "./UsageStartDateTab.module.scss"
import UsageStartDateTable from "./UsageStartDateTable"
import { useUsageStartDate } from "./useUsageStartDate"

import {
	type FragmentType,
	getFragmentData,
	graphql,
} from "@/souhl_admin/gql/__generated__"

export const usageStartDateTabFragment = graphql(/* GraphQL */ `
	fragment UsageStartDateTab on Salon {
		id
		...UsageStartDateTableRow
	}
`)

type Props = {
	companyId: string
	fragment: readonly FragmentType<typeof usageStartDateTabFragment>[]
	onUpdated: () => Promise<unknown>
}

const UsageStartDateTab: FC<Props> = ({ companyId, fragment, onUpdated }) => {
	const salons = getFragmentData(usageStartDateTabFragment, fragment)

	const {
		saving,
		selected,
		selectedCount,
		usageStartDateInput,
		setUsageStartDateInput,
		handleToggle,
		handleToggleAll,
		handleApply,
		handleClear,
	} = useUsageStartDate(companyId, salons, onUpdated)

	return (
		<div className={styles.card}>
			<h2 className={styles.card_title}>利用開始日</h2>

			<div className={styles.bulk_apply_form}>
				<span className={styles.bulk_label}>選択中: {selectedCount}件</span>
				<div className={styles.bulk_right}>
					<input
						type="date"
						className={styles.date_input}
						value={usageStartDateInput}
						onChange={(e) => setUsageStartDateInput(e.target.value)}
					/>
					<button
						type="button"
						className={styles.save_button}
						disabled={saving || selectedCount === 0}
						onClick={handleApply}
					>
						選択した店舗に適用
					</button>
					<button
						type="button"
						className={styles.revert_button}
						disabled={saving || selectedCount === 0}
						onClick={handleClear}
					>
						開始日の削除
					</button>
				</div>
			</div>

			<UsageStartDateTable
				fragment={salons}
				selected={selected}
				onToggle={handleToggle}
				onToggleAll={handleToggleAll}
			/>
		</div>
	)
}

export default UsageStartDateTab
